import { Language } from '../../generated/types';
import { queryStrapi } from '../../utils/query-strapi';

export type QueryData = {
  data: {
    employeeNavigation: {
      data: {
        attributes: {
          overviewLinkText: string;
          benefitsLinkText: string;
          yourSpaceLinkText: string;
          cartLinkText: string;
        };
      } | null;
    };
  };
};

const query = `
query GetNavigation($locale: I18NLocaleCode) {
  employeeNavigation(locale: $locale) {
    data {
      attributes {
        overviewLinkText
        benefitsLinkText
        yourSpaceLinkText
        cartLinkText
      }
    }
  }
}
`;

export async function getStaticProps(
  locale: Language
): Promise<{ props: QueryData }> {
  const queryData = await queryStrapi<QueryData>(query, { locale });

  return {
    props: queryData
  };
}
